import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { Enums } from "../../../helper/constants/enums";
import { getSlotConfigurationAction, insertUpdateSlotConfigurationAction } from "../../actions/slotManagementActions/slotConfigurationAction"

const INITIAL_STATE = {
    SlogConfiguration: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    selectedConfiguration: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    insertUpdateConfigurationDetails: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },

};

const SlotConfigurationReducer = createSlice({
    name: "SlotConfiguration",
    initialState: INITIAL_STATE,
    reducers: {

        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetSlogConfigurationDetailsState(state, action) {
            state.selectedConfiguration = INITIAL_STATE.selectedConfiguration;
            state.insertUpdateConfigurationDetails = INITIAL_STATE.insertUpdateConfigurationDetails;
            // state.changeStatusCustomerDetails = INITIAL_STATE.changeStatusCustomerDetails;
        },
        ResetSlotConfigurationselectState(state, action) {
            state.selectedConfiguration = INITIAL_STATE.selectedConfiguration;
        }
    },
    extraReducers: (builder) => {

        // builder.addCase(getAllCustomersAction.fulfilled, (state, action) => {
        //     state.SlogConfiguration.data = action.payload.data;
        //     state.SlogConfiguration.apiMsg.status = action.meta.requestStatus;
        //     state.SlogConfiguration.apiMsg.message = "success";
        // });
        // builder.addCase(getAllCustomersAction.pending, (state, action) => {
        //     state.SlogConfiguration.apiMsg.status = action.meta.requestStatus;
        // });
        // builder.addCase(getAllCustomersAction.rejected, (state, action) => {
        //     state.SlogConfiguration.apiMsg.message = action.error.message;
        //     state.SlogConfiguration.apiMsg.status = action.meta.requestStatus;
        // });

        builder.addCase(getSlotConfigurationAction.fulfilled, (state, action) => {
            state.selectedConfiguration.data = action.payload.data;
            state.selectedConfiguration.apiMsg.status = action.meta.requestStatus;
            state.selectedConfiguration.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(getSlotConfigurationAction.pending, (state, action) => {
            state.selectedConfiguration.data = null;
            state.selectedConfiguration.apiMsg.message = action.meta.requestStatus;;
            state.selectedConfiguration.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getSlotConfigurationAction.rejected, (state, action) => {
            state.selectedConfiguration.apiMsg.message = action.error.message;
            state.selectedConfiguration.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(insertUpdateSlotConfigurationAction.fulfilled,(state, action) => {

                if (action.meta.arg) {
                    const newData = action.meta.arg;
                    const existingRecords = state.SlogConfiguration.data.records;

                    const index = existingRecords ? existingRecords.findIndex(record => record.businessID === newData.businessID) : -1;

                    if (!newData.businessID) {
                        newData.businessID = action.payload.data.data;
                    }

                    if (index !== -1) {
                        existingRecords[index] = {
                            ...existingRecords[index],
                            ...newData,

                        };
                    }
                    else {

                        existingRecords.push(newData);
                        state.SlogConfiguration.data.totalRecords = state.SlogConfiguration.data.totalRecords + 1;

                    }
                    state.SlogConfiguration.data.records = existingRecords;


                    state.insertUpdateConfigurationDetails.data = {
                        ...newData
                    };
                }

                state.insertUpdateConfigurationDetails.apiMsg.status = action.meta.requestStatus;
                state.insertUpdateConfigurationDetails.apiMsg.message = action.payload.message.message;

                toast.success(action.payload.message.message, {
                    position: "bottom-center",
                    toastId: "success"
                });
            }
        );
        builder.addCase(insertUpdateSlotConfigurationAction.pending,(state, action) => {
                state.insertUpdateConfigurationDetails.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(insertUpdateSlotConfigurationAction.rejected,(state, action) => {

                state.insertUpdateConfigurationDetails.apiMsg.message = action.error.message;
                state.insertUpdateConfigurationDetails.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: "bottom-center",
                    toastId: "error"
                });
            }
        );

    }
});

export const { RESET, ResetSlogConfigurationDetailsState, ResetSlotConfigurationselectState } = SlotConfigurationReducer.actions;
export default SlotConfigurationReducer.reducer;